<template>
  <div>
    <router-view v-bind:news.sync="news"></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
      news: {
        notice_title: '',
        notice_text: '',
        post_date: '',
        file_data: '',
        notice_id: '',
        template: ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Index2.vue